import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";
import "@polymer/polymer/lib/elements/dom-repeat.js";
import "@polymer/polymer/lib/elements/dom-if.js";

import "../EcourseListCard/EcourseListCard";
import "../EcourseEmptyContent/EcourseEmptyContent";

import { _checkPaginationNext, _checkPreviousPage, _checkEmptyData } from "../../../../utils/ecourse";

import "./EcourseList.style";
import Alodokter from "../../../../utils/Alodokter";
import EcourseAnalytics from "../../../../analytics/EcourseAnalytics";

class EcourseList extends PolymerElement {
  static get template() {
    return html `
      <style include="ecourse-list-style"></style>
      <div>
        <dom-repeat items="{{listEcourses}}" as="listEcourse">
          <template>
            <ecourse-list-card
              is-login={{isLogin}}
              user-uid={{userUid}}
              list-ecourse={{listEcourse}}
              page={{page}}
              on-tracking-impression-load="_handleTrackingLoad"
              on-tracking-impression-scroll="_handleTrackingScroll"
            ></ecourse-list-card>
          </template>
        </dom-repeat>
        <template is="dom-if" if="{{_checkEmptyData(listEcourses)}}">
          <ecourse-empty-content title="E-Course Belum Tersedia" description="Mohon maaf, E-Course dengan spesialisasi ini belum tersedia." is-login="true"></ecourse-empty-content>
        </template>
        <div class="container-pagination">
          <template is="dom-if" if="{{_checkPreviousPage(page)}}">
            <div class="btn-pagination" on-click="onPrevPage">< Sebelumnya</div>
          </template>
          <template is="dom-if" if="{{_checkPaginationNext(listEcourses)}}">
            <div class="btn-pagination ml-12" on-click="onNextPage">Selanjutnya ></div>
          </template>
        </div>
      </div>
    `;
  }

  static get properties() {
    return {
      isLogin: {
        type: Number,
      },
      userUid: {
        type: String,
      },
      listEcourses: {
        type: Array,
      },
      page: {
        type: Number,
      },
      speciality: {
        type: String,
      },
      listImpressionsOnLoad: {
        type: Array,
        value: [],
      },
      _checkPaginationNext: {
        type: Function,
        value: () => _checkPaginationNext,
      },
      _checkPreviousPage: {
        type: Function,
        value: () => _checkPreviousPage,
      },
      _checkEmptyData: {
        type: Function,
        value: () => _checkEmptyData,
      },
    };
  }

  ready() {
    super.ready();
    
    EcourseAnalytics.viewItemList(this.listEcourses, false); //GA4

    window.addEventListener("load", function() {
      EcourseAnalytics.viewItemList(this.listImpressionsOnLoad, true);
    }.bind(this));
  }

  onNextPage() {
    const page = this.page + 1;
    this.sendGaEcoursePagination(page, "ecourse_next_pagination_clicked");
    if (this.speciality == "all") {
      window.location = window.location.origin + `/ecourse?page=${page}`;
    } else {
      window.location = window.location.origin + `/ecourse?speciality=${this.speciality}&page=${page}`;
    }
  }

  onPrevPage() {
    const page = this.page - 1;
    this.sendGaEcoursePagination(page, "ecourse_next_previous_clicked");
    if (this.speciality == "all") {
      window.location = window.location.origin + `/ecourse?page=${page}`;
    } else {
      window.location = window.location.origin + `/ecourse?speciality=${this.speciality}&page=${page}`;
    }
  }

  sendGaEcoursePagination(page, event_action) {
    const trackerLabel = `next_page: ${page} | device_category: desktop`
    Alodokter.sendEventGA("e-course landing page", event_action, trackerLabel);
  }

  _handleTrackingLoad(e, data) {
    this.push("listImpressionsOnLoad", data);
  }

  _handleTrackingScroll(e, data) {
    EcourseAnalytics.viewItemList([data], true);
  }
}
customElements.define("ecourse-list", EcourseList);